import {
  GridRowModes,
  GridToolbarContainer,
  GridActionsCellItem,
  useGridApiRef,
  GridBooleanCell,
} from '@mui/x-data-grid-premium';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import { Box, Typography } from '@mui/material';
import { dataGridPremiumColumns } from '../../utils/helper';
import { ButtonUI, DataGridIdentifiers, DatagridPremiumUi } from '../Interface';
import { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import SimpleTaskDialog from './SimpleTaskDialog';
import projectService from '../../service/project.service';
import simpletaskService from '../../service/simpletask.service';

const ProjectSimpleTasksTable = ({ selectedValues, setRefetchTable, setSelectedValues }) => {
  const apiRef = useGridApiRef();
  const [taskChanged, setTaskChanged] = useState(false);
  const [taskDialog, setTaskDialog] = useState({ open: false, data: {} });

  useEffect(() => {
    if (taskChanged) {
      getProjectById();
      setRefetchTable(true);
    }
  }, [taskChanged]);

  const getProjectById = () => {
    if (selectedValues.projectId) {
      projectService.getProjectById(selectedValues.projectId).then((data) => {
        setSelectedValues(data);
        setTaskChanged(false);
      });
    }
  };

  const getTaskById = (simpleTaskId) => {
    setTaskDialog((prev) => ({
      ...prev,
      open: true,
    }));

    simpletaskService.getTaskById(simpleTaskId).then((data) => {
      setTaskDialog((prev) => ({
        ...prev,
        data,
      }));
    });
  };

  const columns = dataGridPremiumColumns([
    {
      field: 'simpleTaskName',
      headerName: 'Feladat rövid neve',
      type: 'string',
    },
    {
      field: 'endDate',
      headerName: 'Befejező dátum',
      type: 'date',
      valueGetter: (_data, row) => {
        return new Date(row.endDate);
      },
      renderCell: (data) => {
        return dayjs(data.row.endDate).format('YYYY.MM.DD');
      },
    },
    {
      field: 'statusId',
      headerName: 'Státusz',
      type: 'string',
      renderCell: (data) => {
        return data.row.status?.itemName;
      },
    },
    {
      field: 'simpleTaskDescription',
      headerName: 'Megjegyzés',
      type: 'string',
    },
    {
      field: 'more',
      headerName: 'Megtekint',
      type: 'actions',
      renderCell: (params) => <RemoveRedEyeIcon color="black" onClick={() => getTaskById(params.id)} />,
    },
  ]);

  return (
    <>
      <div className="overflow-x-auto">
        <div className="align-middle">
          <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg">
            <DatagridPremiumUi
              apiRef={apiRef}
              datagridIdentifier={DataGridIdentifiers.ProjectSimpleTasksTable}
              height={460}
              columns={columns}
              rows={selectedValues?.simpleTask ?? []}
              headerFilters={false}
              slots={{
                toolbar: null,
              }}
              getRowId={(row) => row.simpleTaskId}
              getRowHeight={() => 'auto'}
            />
          </div>
        </div>
      </div>

      <SimpleTaskDialog
        open={taskDialog.open}
        handleClose={() => setTaskDialog({ open: false, data: {} })}
        task={taskDialog.data}
        setTaskChanged={setTaskChanged}
      />
    </>
  );
};

export default ProjectSimpleTasksTable;
